// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Application__FormController from "./application/form_controller"
application.register("application--form", Application__FormController)

import Application__InstructionsController from "./application/instructions_controller"
application.register("application--instructions", Application__InstructionsController)

import AsyncDownloadController from "./async_download_controller"
application.register("async-download", AsyncDownloadController)

import ChartStatesController from "./chart_states_controller"
application.register("chart-states", ChartStatesController)

import ConfirmClickController from "./confirm_click_controller"
application.register("confirm-click", ConfirmClickController)

import EmbedSpinnerController from "./embed_spinner_controller"
application.register("embed-spinner", EmbedSpinnerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlashDispatcherController from "./flash_dispatcher_controller"
application.register("flash-dispatcher", FlashDispatcherController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import Form__AutofocusController from "./form/autofocus_controller"
application.register("form--autofocus", Form__AutofocusController)

import Form__BreakoutController from "./form/breakout_controller"
application.register("form--breakout", Form__BreakoutController)

import Form__IdController from "./form/id_controller"
application.register("form--id", Form__IdController)

import Form__ModalComponentCloserController from "./form/modal_component_closer_controller"
application.register("form--modal-component-closer", Form__ModalComponentCloserController)

import Form__RangeNumberController from "./form/range_number_controller"
application.register("form--range-number", Form__RangeNumberController)

import Form__ReloadOnChangeController from "./form/reload_on_change_controller"
application.register("form--reload-on-change", Form__ReloadOnChangeController)

import Form__SpinnerController from "./form/spinner_controller"
application.register("form--spinner", Form__SpinnerController)

import Form__TurnstileController from "./form/turnstile_controller"
application.register("form--turnstile", Form__TurnstileController)

import Form__UrlController from "./form/url_controller"
application.register("form--url", Form__UrlController)

import Manager__FormController from "./manager/form_controller"
application.register("manager--form", Manager__FormController)

import ManagerSwitchComponentController from "./manager_switch_component_controller"
application.register("manager-switch-component", ManagerSwitchComponentController)

import ModalComponentController from "./modal_component_controller"
application.register("modal-component", ModalComponentController)

import OpenModalComponentController from "./open_modal_component_controller"
application.register("open-modal-component", OpenModalComponentController)

import QrcodeController from "./qrcode_controller"
application.register("qrcode", QrcodeController)

import RemoveController from "./remove_controller"
application.register("remove", RemoveController)

import ShowController from "./show_controller"
application.register("show", ShowController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import Subscription__FormController from "./subscription/form_controller"
application.register("subscription--form", Subscription__FormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimeRange__FormController from "./time_range/form_controller"
application.register("time-range--form", TimeRange__FormController)

import TimeRange__SortableController from "./time_range/sortable_controller"
application.register("time-range--sortable", TimeRange__SortableController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboFrameReloaderController from "./turbo_frame_reloader_controller"
application.register("turbo-frame-reloader", TurboFrameReloaderController)
